import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, withLatestFrom, map } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { LocationChangeAction, LOCATION_CHANGE } from 'connected-react-router';
import { HideSnackbar } from '@webapp/store/ui/action-creators';
import { NoOp } from '../../ui/action-creators';

export const hideLockedReleaseSnackbarEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, LocationChangeAction<any>>(LOCATION_CHANGE),
    withLatestFrom(state$),
    filter(
      ([_, state]) => !state.router.location.pathname.startsWith('/release')
    ),
    map(([_, state]) => {
      if (state?.ui?.snackbar['RELEASE_LOCKED'] !== undefined) {
        return new HideSnackbar('RELEASE_LOCKED');
      }
      return new NoOp();
    })
  );
